/** Tab-paywall gate: trial reassurance → notifications → paywall (fullscreen). */
export const TAB_GATE_TOTAL_STEPS = 3;

export const TAB_GATE_SCREEN_IDS = [
  "trial_reassurance",
  "notifications",
  "paywall",
] as const;

export type TabGateScreenId = (typeof TAB_GATE_SCREEN_IDS)[number];

export function tabGateStepToScreenId(step: number): TabGateScreenId {
  const index = Math.max(1, Math.min(TAB_GATE_TOTAL_STEPS, step)) - 1;
  return TAB_GATE_SCREEN_IDS[index]!;
}
